export const MOBILE_MIN_ROW_HEIGHT = 60;
export const DESKTOP_MIN_ROW_HEIGHT = 80;
export const EXPORT_ROW_HEIGHT = 80;
export const INITIAL_UNMEASURED_ROW_HEIGHT = MOBILE_MIN_ROW_HEIGHT;

export function getMinimumRowHeight(isMobile: boolean) {
  return isMobile ? MOBILE_MIN_ROW_HEIGHT : DESKTOP_MIN_ROW_HEIGHT;
}
